<template>
  <div class="login-box">
  <div class="login-logo">
    <span class="logo" v-html="logos"></span>
  </div>
  <!-- /.login-logo -->
  <div class="" style="width: 100%" v-if="acceptance" >
    <span class="logo" style="width: 100%;" v-html="logos1"></span>
    <span class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span><br>
      <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 10px;text-align: center;"><strong>{{successmsg}}!</strong></p>
      <p class="lead success-text-align" style="font-size:14px;color:#5bad2b;line-height: 10px;text-align: center;"><a @click="gotoLogin()">Click here to Login</a></p>
      <br>
  </div>
  <div class="login-box-body" v-if="!acceptance">
    <div class="box-header with-border mb-10">
      <h4 class="box-title pull-left">Set Password</h4>
    </div>
    <b-form class="form-signup mb-1" v-on:submit.prevent="onSubmit" novalidate>
      <div class="form-label-group">
        <div class="form-group has-feedback">
        <b-form-input @input="checkPassword" autocomplete="new-password" type="password" class="form-control custom-input" placeholder="Password*" v-model.lazy.trim="$v.form.user_password.$model" :state="chkState('user_password')" />
        <!-- <span class="uil uil-eye field-icon form-control-feedback" v-if="passwordFieldType == 'text'" @click="switchVisibility"></span>
        <span class="uil uil-eye-slash field-icon form-control-feedback" v-if="passwordFieldType == 'password'" @click="switchVisibility"></span> -->
        <div>
          <p style="font-size: 11px" class="error-msg" v-if="!chkState('user_password')"><span>* Must have 8 characters with 1 upper case letter, 1 number & 1 special character</span></p>
          <!-- <p class="color-g pull-right" v-if="paswordStrength === 25">Poor</p>
          <p class="color-g pull-right" v-if="paswordStrength === 50">Fair</p>
          <p class="color-g pull-right" v-if="paswordStrength === 75">Good</p>
          <p class="color-g pull-right" v-if="paswordStrength === 100">Excellent</p> -->
          <!-- <p v-if="!$v.form.user_password.minLength" class="error-msg">* Please enter a valid mobile no</p> -->
        </div>
        </div>
      </div>
      <!-- <span class="pwd_info" v-if="!chkState('user_password')">Must have 8 characters, 1 special character, 1 number</span> -->
      <!-- <span class="pwd_info_float_right" v-if="!chkState('user_password') && paswordStrength < 25">Poor</span> -->
      <div class="form-label-group form-forgot-password">
        <div class="form-group has-feedback">
          <b-form-input :type="passwordFieldType" autocomplete="new-password" class="form-control" placeholder="Confirm Password* " v-model.lazy.trim="$v.form.repeatPassword.$model" :state="chkState('repeatPassword')" />
          <span class="uil uil-eye form-control-feedback" v-if="passwordFieldType == 'text'" @click="switchVisibility"></span>
          <span class="uil uil-eye-slash form-control-feedback" v-if="passwordFieldType == 'password'" @click="switchVisibility"></span>
          <div v-if="$v.form.repeatPassword.$error">
            <p v-if="!$v.form.repeatPassword.required" class="error-msg">* Enter confirm password</p>
            <p v-if="!$v.form.repeatPassword.sameAsPassword && form.repeatPassword.length > 0" class="error-msg">* Passwords do not match</p>
          </div>
        </div>
      </div>

      <button class="btn btn-md btn-success btn-block mt-4" type="submit">Set Password</button>
      <span class="pwd_info mt-2" v-if="oldPasswordMatched">Do not type existing password, type new password</span>
    </b-form>
  </div>
  <!-- /.login-box-body -->
</div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, sameAs } from 'vuelidate/lib/validators'
import { BaseURLV3 } from '../shared/classes'
import axios from 'axios'
import { logo } from '../shared/svg_forget'
import router from '../router/index'
import { REGISTERATION_SUCCESS, logo1 } from '../shared/svg'

const formShape = {
  user_password: '',
  repeatPassword: ''
}
export default {
  name: 'setPassword',
  data () {
    return {
      form: Object.assign({}, formShape),
      password: null,
      password_length: 0,
      typed: false,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      hasError: false,
      userStatus: false,
      currentModel: '',
      paswordStrength: 0,
      userEmail: this.$route.params.email,
      userToken: this.$route.params.key,
      passwordFieldType: 'password',
      showMessage: false,
      passwordStatus: '',
      logos: logo,
      passwordStorage: '',
      oldPasswordMatched: false,
      oldpwd: '',
      acceptance: false,
      successmsg: '',
      REGISTERATION_SUCCESS_ICON: REGISTERATION_SUCCESS,
      logos1: logo1
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      user_password: {
        required,
        maxLength: maxLength(22),
        strongPassword (UserPassword) {
          return (
            /[a-z]/.test(UserPassword) && // checks for a-z
            /[0-9]/.test(UserPassword) && // checks for 0-9
            /\W|_/.test(UserPassword) && // checks for special char
            UserPassword.length >= 6
          )
        }
      },
      repeatPassword: {
        required,
        sameAsPassword: sameAs('user_password')
      }
    }
  },
  created () {
    // this.setPasswordStatus()
    localStorage.clear()
  },
  methods: {
    // setPasswordStatus () {
    //   axios.get(BaseURLV3 + '/profile/user_password_validation/' + this.$route.params.email + '/' + this.$route.params.key, {
    //     headers: {
    //       Pragma: 'no-cache'
    //     }
    //   }).then(response => {
    //     console.log(response.data.message.length)
    //     if (response.data.message.length === 1) {
    //       this.oldpwd = response.data.message[0].oldpassword
    //     } else {
    //       window.location.href = '/Login'
    //     }
    //   })
    // },
    switchVisibility () {
      this.password_length = this.form.user_password.length
      console.log(this.form.user_password)
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    checkPassword () {
      this.password_length = this.form.user_password.length
      // const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

      if (this.form.user_password.length > 8) {
        this.contains_eight_characters = true
        this.paswordStrength1 = 25
      } else {
        this.paswordStrength1 = 0
        this.contains_eight_characters = false
      }

      this.contains_number = /\d/.test(this.form.user_password)
      this.contains_uppercase = /[A-Z]/.test(this.form.user_password)
      // this.contains_special_character = format.test(this.form.user_password)
      if (this.contains_number) {
        this.paswordStrength2 = 25
      } else {
        this.paswordStrength2 = 0
      }
      if (this.contains_uppercase) {
        this.paswordStrength3 = 25
      } else {
        this.paswordStrength3 = 0
      }
      // if (this.contains_special_character) {
      this.paswordStrength4 = 25
      // } else {
      //   this.paswordStrength4 = 0
      // }
      this.paswordStrength = (this.paswordStrength1 + this.paswordStrength2 + this.paswordStrength3 + this.paswordStrength4)

      if (this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true) {
        this.valid_password = true
      } else {
        this.valid_password = false
      }
    },
    onSubmit () {
      console.log(this.form.user_password)
      if (this.oldpwd === null) {
        this.oldpwd = ''
      }
      this.password_length = this.form.user_password.length
      this.passwordStorage = this.oldpwd
      const a = this.passwordStorage.split('|WEBsCREENIT|')
      const c = this.form.user_password
      const d = false
      // console.log(a)
      if (a.find(element => element === this.form.user_password)) {
        this.oldPasswordMatched = true
      } else {
        if (!d && a.length === 5) {
          a.shift()
          a.push(c)
          // console.log(a)
          // console.log(a.join().replace(/,/g, '|WEBsCREENIT|'))
          this.onSubmitValidation(a.join().replace(/,/g, '|WEBsCREENIT|'))
        } else if (!d && a.length < 5) {
          a.push(c)
          // console.log(a)
          // console.log(a.join().replace(/,/g, '|WEBsCREENIT|'))
          this.onSubmitValidation(a.join().replace(/,/g, '|WEBsCREENIT|'))
        }
      }
    },
    onSubmitValidation (val) {
      if (this.validate()) {
        this.$nextTick(() => {
          if (this.$route.params.type === '1') {
            const data = {
              password: this.form.user_password
            }
            // submit
            localStorage.clear()
            axios.post(BaseURLV3 + '/org/' + this.$route.params.key + '/verify', data).then(response => {
              localStorage.setItem('user_email', this.$route.params.email)
              localStorage.setItem('user_id', this.$route.params.key)
              localStorage.setItem('user_password', this.form.user_password)
              // localStorage.setItem('user__details', JSON.stringify(response.data.userinfo))
              localStorage.setItem('token', JSON.stringify(response.data.token))
              // console.log(response.data.userinfo)
              console.log(response.data.token)
              if (this.$route.params.type === '1') {
                router.replace({ name: 'organization_profile_update_v3' })
              } else if (this.$route.params.type === '2') {
                // this.$awn.success('Login success!')
                // router.push({ name: 'DashboardV3' })
                router.replace({ name: 'LoginV3' })
              } else {
                router.replace({ name: 'LoginV3' })
              }
            }).catch(e => {
              console.log(e)
            })
          } else if (this.$route.params.type === '2') {
            const data = {
              user_id: this.$route.params.key,
              password: this.form.user_password
            }
            // submit
            localStorage.clear()
            axios.post(BaseURLV3 + '/reset_password', data).then(response => {
              localStorage.setItem('user_email', this.$route.params.email)
              localStorage.setItem('user_id', this.$route.params.key)
              localStorage.setItem('user_password', this.form.user_password)
              // localStorage.setItem('user__details', JSON.stringify(response.data.userinfo))
              // localStorage.setItem('token', JSON.stringify(response.data.token))
              // console.log(response.data.userinfo)
              // console.log(response.data.token)
              if (this.$route.params.type === '1') {
                router.replace({ name: 'organization_profile_update_v3' })
              } else if (this.$route.params.type === '2') {
                // this.$awn.success('Login success!')
                // router.push({ name: 'DashboardV3' })
                router.replace({ name: 'LoginV3' })
              } else {
                router.replace({ name: 'LoginV3' })
              }
            }).catch(e => {
              console.log(e)
            })
          } else if (this.$route.params.type === '3') {
            const data = {
              password: this.form.user_password
            }
            axios.post(BaseURLV3 + '/org/' + this.$route.params.key + '/verify', data).then(response => {
              if (response.data.success) {
                this.acceptance = true
                this.successmsg = 'User created successfully'
              } else {

              }
            }).catch(e => {
              console.log(e)
            })
          }
        })
      } else {
        console.log('else................')
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    gotoLogin () {
      router.replace({ name: 'LoginV3' })
    }
  }
}
</script>

<style scoped>
.passwardcompare {
  margin-top: 9px !important;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: -10px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  width: 44%;
  margin-left: 3%;
  margin-right: 3%;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}
.form-content {
    width: auto;
}
.box {
  border-top: 0px solid #d2d6de;
  border-radius: 0px;
}
.form-content form {
    margin-bottom: 30px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}
.box-header .box-title {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    line-height: 1;
    color:black;
}
.form-content .form-items {
    max-width: 540px;
}
.form-label-group {
    position: relative;
    margin-bottom: 1rem;
}
.form-items {
  margin-top: 8% ;
}
.mt-4 {
    margin-top: 4px !important;
}
html, body {
  background-color: #F5F5F5 !important;
}
.logo-size {
  width: 50%;
}
</style>
